import {
    DamageIssueType,
    DeliveryIssueTypeInternational,
    DocumentationIssueType,
    InvoiceIssueTypeInternational,
    ItemOrQuantityIssueTypeInternational,
    NatureOfComplaintInternational,
    OrderEntryIssueTypeInternational,
    ProductDatingUponReceiptIssueTypeInternational,
    QualityIssueType,
    TemperatureIssueType
} from '@cod-monorepo/interfaces';

export const config = {
    [NatureOfComplaintInternational.ORDER_ENTRY]: {
        label: 'Revise Order Entry Issue Type as a result of Investigation?',
        options: Object.values(OrderEntryIssueTypeInternational)
    },
    [NatureOfComplaintInternational.ITEM_OR_QUANTITY]: {
        label: 'Revise Item or Quantity Issue Type as a result of Investigation?',
        options: Object.values(ItemOrQuantityIssueTypeInternational)
    },
    [NatureOfComplaintInternational.PRODUCT_DATING]: {
        label: 'Revise Product Dating Issue Type as a result of Investigation?',
        options: Object.values(ProductDatingUponReceiptIssueTypeInternational)
    },
    [NatureOfComplaintInternational.PRODUCT_DAMAGE]: {
        label: 'Revise Product Damage Issue Type as a result of Investigation?',
        options: Object.values(DamageIssueType)
    },
    [NatureOfComplaintInternational.PRODUCT_TEMPERATURE]: {
        label: 'Revise Product Temperature Issue Type as a result of Investigation?',
        options: Object.values(TemperatureIssueType)
    },
    [NatureOfComplaintInternational.DELIVERY]: {
        label: 'Revise Delivery Issue Type as a result of Investigation?',
        options: Object.values(DeliveryIssueTypeInternational)
    },
    [NatureOfComplaintInternational.DOCUMENTATION]: {
        label: 'Revise Documentation Error Issue Type as a result of Investigation?',
        options: Object.values(DocumentationIssueType)
    },
    [NatureOfComplaintInternational.INVOICE_ERROR]: {
        label: 'Revise Invoice Error Issue Type as a result of Investigation?',
        options: Object.values(InvoiceIssueTypeInternational)
    },
    [NatureOfComplaintInternational.QUALITY]: {
        label: 'Revise Quality Issue Type as a result of Investigation?',
        options: Object.values(QualityIssueType)
    }
};
